import React from "react";
import { IAutomationTask } from "../../interfaces/IAutomationTask";
import { IRole } from "../../interfaces/IRole";
import { ITaskState } from "../../interfaces/ITaskState";
import { ITaskType } from "../../interfaces/ITaskType";
import { ITaskPriority } from "../../interfaces/ITaskPriority";
import { Autocomplete, AutocompleteRenderInputParams, Grid, MenuItem, TextField } from "@mui/material";
import { CustomeTextField } from "../core/CustomeTextField";
import { CustomeDateTimePicker } from "../core/CustomeDateTimePicker";
import { getTmpId } from "../core/generic_helpders";

interface IProps {
    autoTask: IAutomationTask;
    setAutoTask: Function;
    roleArray: IRole[];
    taskStateArray: ITaskState[];
    taskTypeArray: ITaskType[];
    taskPriorityArray: ITaskPriority[];
}

export const getEmptyAutomationTask = (autoTaskArray: IAutomationTask[], idAutomation: number): IAutomationTask => {
    return {
        id: getTmpId(autoTaskArray),
        Automation: idAutomation,
        deadline: 0,
        description: "",
        return_message: false,
        TaskPriority: 1,
        TaskState: 1,
        TaskType: 1,
        title: "",
        task_for_roles: [],
    };
};

export const AutomationTaskEdit: React.FC<IProps> = ({
    autoTask,
    setAutoTask,
    roleArray,
    taskStateArray,
    taskTypeArray,
    taskPriorityArray,
}) => {
    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={4}>
                    <CustomeTextField
                        label="Deadline in Tage nach Erstellung"
                        attr="deadline"
                        object={autoTask}
                        setObject={setAutoTask}
                        type="number"
                        null
                    />
                </Grid>
                <Grid item xs={8}></Grid>

                <Grid item xs={4}>
                    <CustomeTextField
                        label="Status"
                        attr="TaskState"
                        object={autoTask}
                        setObject={setAutoTask}
                        type="select"
                    >
                        {taskStateArray.map((x) => (
                            <MenuItem key={`edit-taskstate-${x.id}`} value={x.id}>
                                {x.taskState}
                            </MenuItem>
                        ))}
                    </CustomeTextField>
                </Grid>
                <Grid item xs={4}>
                    <CustomeTextField
                        label="Priorität"
                        attr="TaskPriority"
                        object={autoTask}
                        setObject={setAutoTask}
                        type="select"
                    >
                        {taskPriorityArray.map((x) => (
                            <MenuItem key={`edit-taskPriority-${x.id}`} value={x.id}>
                                {x.taskPriority}
                            </MenuItem>
                        ))}
                    </CustomeTextField>
                </Grid>
                <Grid item xs={4}>
                    <CustomeTextField
                        label="Art"
                        attr="TaskType"
                        object={autoTask}
                        setObject={setAutoTask}
                        type="select"
                    >
                        {taskTypeArray.map((x) => (
                            <MenuItem key={`edit-taskTypeArray-${x.id}`} value={x.id}>
                                {x.taskType}
                            </MenuItem>
                        ))}
                    </CustomeTextField>
                </Grid>

                <Grid item xs={12}>
                    <CustomeTextField
                        label="Titel"
                        attr="title"
                        object={autoTask}
                        setObject={setAutoTask}
                        type="string"
                        required
                    />
                </Grid>

                <Grid item sm={12}>
                    <Autocomplete
                        multiple
                        fullWidth
                        options={roleArray.filter((role) => role.id !== 100)}
                        getOptionLabel={(option: IRole) => {
                            return option.role;
                        }}
                        value={roleArray.filter((role) => autoTask.task_for_roles.includes(role.id))}
                        onChange={(_, newValue) => {
                            setAutoTask({
                                ...autoTask,
                                task_for_roles: newValue.map((x) => x.id),
                            });
                        }}
                        renderInput={(params: AutocompleteRenderInputParams) =>
                            React.createElement(TextField, {
                                ...(params as any),
                                label: "Empfängerrollen",
                                variant: "standard",
                            })
                        }
                        size="small"
                    />
                </Grid>

                <Grid item xs={12}>
                    <CustomeTextField
                        label="Beschreibung"
                        attr="description"
                        object={autoTask}
                        setObject={setAutoTask}
                        type="string"
                        rows={5}
                    />
                </Grid>
            </Grid>
        </>
    );
};
